import { env } from '../env';
import { AdminTipDetail, AdminTipSummary, TipCreateCommand, TipUpdateCommand } from '../types/tip';

const BASE_URL = env.apiUrl;

function authHeaders(accessToken: string): HeadersInit {
  return { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' };
}

export async function adminListTips(accessToken: string): Promise<AdminTipSummary[]> {
  const res = await fetch(`${BASE_URL}/api/tips/admin`, { headers: authHeaders(accessToken) });
  if (!res.ok) throw new Error('Failed to load tips');
  return res.json();
}

export async function adminGetTip(accessToken: string, tipId: number): Promise<AdminTipDetail> {
  const res = await fetch(`${BASE_URL}/api/tips/${tipId}/admin`, { headers: authHeaders(accessToken) });
  if (!res.ok) throw new Error('Failed to load tip');
  return res.json();
}

export async function createTip(accessToken: string, cmd: TipCreateCommand): Promise<{ tipId: number }> {
  const res = await fetch(`${BASE_URL}/api/tips`, {
    method: 'POST',
    headers: authHeaders(accessToken),
    body: JSON.stringify(cmd),
  });
  if (!res.ok) throw new Error('Failed to create tip');
  return res.json();
}

export async function updateTip(
  accessToken: string,
  tipId: number,
  cmd: TipUpdateCommand
): Promise<{ tipId: number }> {
  const res = await fetch(`${BASE_URL}/api/tips/${tipId}`, {
    method: 'PUT',
    headers: authHeaders(accessToken),
    body: JSON.stringify(cmd),
  });
  if (!res.ok) throw new Error('Failed to update tip');
  return res.json();
}

export async function deleteTip(accessToken: string, tipId: number): Promise<void> {
  const res = await fetch(`${BASE_URL}/api/tips/${tipId}`, {
    method: 'DELETE',
    headers: authHeaders(accessToken),
  });
  if (!res.ok) throw new Error('Failed to delete tip');
}
